<a name="top-page"></a>

<swiper-home-header></swiper-home-header>

<section class="main-section no-padding bg-primary">
    <div class="compact-container container-fluid">
        <banner-main-stats></banner-main-stats>
    </div>
</section>

<section class="main-section-compact ">
    <div class="container-fluid compact-container-1245">
        <div class="row">
            <div class="col-12">
                <h2 class="section-heading-bicolor section-heading-h2 section-heading-md-mgn text-center">Da el
                    siguiente paso en tu&nbsp;<span class="enphasis">carrera laboral</span></h2>
                <p class="after-heading-text text-center">Conoce los proyectos educativos de cientos de instituciones
                </p>
            </div>
        </div>

        <swiper-home-institution-pro (eventSendResume)="eventSendResume($event)"></swiper-home-institution-pro>

    </div>
</section>

<a name="anuncios"></a>

<section class="main-section-compact bg-color-light-gray-2">

    <job-search-category></job-search-category>

</section>

<section class="main-section-compact">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h2 class="section-heading-bicolor-2 text-center">Partners de&nbsp;<span
                        class="enphasis">ProfeJOBS</span></h2>
                <div class="images-group">
                    <div class="wrap-img">
                        <img loading="lazy" alt="Logotipo de Northwestern university" src="images/partner1.png" />
                    </div>
                    <div class="wrap-img">
                        <img loading="lazy" alt="Logotipo de Caja LOs Andes" src="images/partner2.png" />
                    </div>
                    <div class="wrap-img">
                        <img loading="lazy" alt="Logotipo de Socialab" src="images/partner3.png" />
                    </div>
                    <div class="wrap-img">
                        <img loading="lazy" alt="Logotipo de CORFO" src="images/partner4.png" />
                    </div>
                    <div class="wrap-img">
                        <img loading="lazy" alt="Logotipo de Start Up Chile" src="images/partner5.png" />
                    </div>
                    <div class="wrap-img">
                        <img loading="lazy" alt="Logotipo convenio marco Chile Compra" src="images/partner6.png" />
                    </div>
                    <div class="wrap-img">
                        <img loading="lazy" alt="Logotipo convenio marco Chile Compra" src="images/partner7.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-resume-send #resumeSend (eventResumeSend)="eventModalResumeSend($event)"></app-resume-send>